import { FormCompactSelect } from "../../../common/form/formcompactselect.jsx";
import { FormCompactInput } from "../../../common/form/formcompactinput.jsx";
import { Alert, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { FC, useContext, useEffect } from "react";
import { LoadingWrapper } from "@hr/common/LoadingState";
import { VacationYearOption } from "./ManualTab";
import { ManualTabContext } from "@hr/statisticsview/vacancy/ManualTab/ManualTabContext";
import { useGetCompanyBalances } from "@hr/api/endpoints";

const cardStyles = { padding: "0.25rem 0.5rem" };

export const ManualTabFilters: FC<{ vacationYears: VacationYearOption[] }> = ({ vacationYears }) => {
  const { t } = useTranslation();
  const { watch, setValue, getValues } = useFormContext();
  const organizationVacationYearId = watch("organizationVacationYearId");
  const paymentGroupQuery = watch("paymentGroup");
  const { setVacationBalances } = useContext(ManualTabContext);
  const { data: vacationBalancesData } = useGetCompanyBalances({
    organizationVacationYearId: getValues("organizationVacationYearId").value,
  });

  useEffect(() => {
    const selectedOption = vacationYears?.find((option) => option.id === Number(organizationVacationYearId.value));
    setValue("start", selectedOption ? selectedOption.vacancyYearStarted : "");
    setValue("end", selectedOption ? selectedOption.vacancyYearEnded : "");
  }, [organizationVacationYearId]);

  const vacationYearsToUse = vacationYears?.map((option) => ({
    value: option.id,
    label: option.annualVacationYear,
  }));

  const searchPersonByPaymentGroup = () => {
    if (!vacationBalancesData) {
      return;
    }

    if (
      !paymentGroupQuery ||
      !vacationBalancesData ||
      paymentGroupQuery.length === 0 ||
      paymentGroupQuery.trim() === ""
    ) {
      setVacationBalances(vacationBalancesData || []);
      return;
    }

    const filteredBalances = [...vacationBalancesData].filter(
      (balance) => balance.paymentGroup?.toLowerCase().indexOf(paymentGroupQuery.toLowerCase()) !== -1,
    );
    setVacationBalances(filteredBalances || []);
  };

  useEffect(() => {
    searchPersonByPaymentGroup();
  }, [paymentGroupQuery]);

  useEffect(() => {
    if (vacationBalancesData) {
      setVacationBalances(
        vacationBalancesData?.map((balance) => {
          if (!balance.paymentGroup) {
            // @ts-ignore
            balance.paymentGroup = "";
            return balance;
          }
          return balance;
        }),
      );
    }
  }, [vacationBalancesData]);

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <div className="d-flex gap-2">
          <Card>
            <Card.Body style={cardStyles}>
              <LoadingWrapper isLoading={!vacationYears}>
                <FormCompactSelect
                  label={`${t("VacationYear","Lomavuosi")}`}
                  name="organizationVacationYearId"
                  options={vacationYearsToUse}
                />
              </LoadingWrapper>
            </Card.Body>
          </Card>
          <Card>
            <Card.Body style={cardStyles}>
              <FormCompactInput
                label={`${t("VacancyYearStarted","Lomavuoden alku")}`}
                name="start"
                inputProps={{ style: { width: "16rem" } }}
                disabled
              />
            </Card.Body>
          </Card>
          <Card>
            <Card.Body style={cardStyles}>
              <FormCompactInput
                label={`${t("VacancyYearEnded","Lomavuoden loppu")}`}
                name="end"
                inputProps={{ style: { width: "16rem" } }}
                disabled
              />
            </Card.Body>
          </Card>
          <Card>
            <Card.Body style={cardStyles}>
              <FormCompactInput
                label={`${t("PaymentGroup", "Maksuryhmä")}`}
                name="paymentGroup"
                inputProps={{ style: { width: "16rem" }, placeholder: "" }}
              />
            </Card.Body>
          </Card>
        </div>
      </div>
      <Alert className="w-auto  mb-0">
        {t("AnnualVacationBox",
          'Edited cells are highlighted in purple. Remember to save changes with the "Save annual vacation" button or discard them with the "Discard changes" button.'
        )}
      </Alert>
    </>
  );
};
